import { FilesStateInterface } from './files.reducer';
import { createSelector } from '@ngrx/store';
import { DownloadUrlDto } from '@careapp-group/ng-sdk-v2-new';
import { isAfter, parseISO } from 'date-fns';

const getFilesState = (state: { files: FilesStateInterface }) => state.files;

const getCurrentUrl = (fileId: string) =>
  createSelector(getFilesState, (state: FilesStateInterface) => {
    const current: DownloadUrlDto = state.urls[fileId];
    if ((current != null && isAfter(parseISO(current.expiresAt), Date.now())) ?? true) {
      return current.url;
    }
    return null;
  });

export const getUrls = createSelector(getFilesState, (state) => state?.urls ?? {});

const filesLoading = (ids: string[]) =>
  createSelector(getFilesState, (state: FilesStateInterface) => {
    return ids.some((id) => state.loadingIds[id] === true ?? false);
  });

export const getFileHistoryLoading = createSelector(getFilesState, (state: FilesStateInterface) => {
  if (state && state.loadingIds) {
    return Object.values(state.loadingIds).some((isLoading) => isLoading === true);
  }
  return false;
});
export const getFileHistory = createSelector(getFilesState, (state: FilesStateInterface) => {
  return state?.fileHistory;
});

export const FilesSelectors = {
  getFilesState,
  getCurrentUrl,
  filesLoading,
};
